import angular from 'angular';

angular
  .module('cloudX')
  .controller('EditRelationLinkDialogCtrl', [
    'resourceFactorySvc',
    'flySvc',
    '$element',
    'close',
    'relationLink',
    'updateLink',
    'parentId',
    'enumCacheSvc',
    editRelationLinkDialogCtrl,
  ]);

function editRelationLinkDialogCtrl(
  resourceFactorySvc,
  flySvc,
  $element,
  close,
  relationLink,
  updateLink,
  parentId,
  enumCacheSvc,
) {
  var vm = this;
  vm.loading = true;
  vm.shareholderGroups = null;

  vm.relationLink = relationLink || {
    extraValues: {},
  };

  var resource = resourceFactorySvc.get('relationLink');

  if (relationLink.id) {
    resource
      .getDetails({
        id: relationLink.id,
      })
      .$promise.then(
        function(result) {
          vm.loading = false;
          if (result) {
            vm.relationLink.toRelation = parentId == result.target.id ? {...result.source} : {...result.target};
            delete result.target;
            delete result.source;
            vm.relationLink.extraValues = result;
          }
        },
        function(error) {
          vm.loading = false;
          showError(error);
        },
      );
  }

  enumCacheSvc.get('marriageregime').then(function(data) {
    vm.marriageRegimesForLegalCohabitation = data.filter(x => 
      x.key === 1 || x.key === 2 || x.key === 3);
  });

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };

  vm.updateValue = function(property, value) {
    var model = angular.copy(vm.relationLink);

    if (model[property] === value) return false;

    model[property] = value;

    return updateLink(model);
  };

  vm.submit = function(value, field) {
    if (vm.relationLink.extraValues[field] === value) return false;

    if (field === 'representedByRelation') {
      if (!!value && !value.id) {
        return '';
      }
    }

    var model = angular.copy(vm.relationLink);

    model.extraValues[field] = value;

    //Remove unnecessary properties before submitting
    if (model.extraValues.target) delete model.extraValues.target;
    if (model.info) delete model.info;
    if (model.target) delete model.target;

    const transformed = resourceFactorySvc.setDatePropsToISO(model);
    transformed.extraValues = JSON.stringify(transformed.extraValues);

    return resource.updateDetails(transformed).$promise.then(
      function(result) {
        if (result) {
          vm.relationLink.extraValues = result;
        }
        flySvc.success('msgConfirmChange');
        return false;
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
        return '';
      },
    );
  };

  vm.loadShareholderGroups = function() {
    if (vm.shareholderGroups !== null) return;
    vm.shareholderGroups = [];
    resource.shareholderGroups({ id: vm.relationLink.from }, function(result) {
      vm.shareholderGroups = result || [];
    });
  };
  if (vm.relationLink.linkType === 6) {
    vm.loadShareholderGroups();
  }

  vm.cancel = function() {
    $element.modal('hide');
    close(true, 500); // always refresh changes after because we cant rely on setting a property to check for changes (if editable component is open and user clicked on close for example)
  };
}
